import React, { lazy, Suspense} from 'react';
import { Helmet } from "react-helmet";
import Loader from '../components/Loader';
import Hero from "../components/Hero";
import Carousel from "../components/Carousel";



// Ленивая загрузка компонентов
const LazyCarsFeature = lazy(() => import("../components/CarsFeature"));
const LazyFeatures = lazy(() => import("../components/Features"));
const LazyTestimonials = lazy(() => import("../components/Testimonials"));
const LazyCTA = lazy(() => import("../components/CTA"));

const SEO_DATA = {
  title: "Аренда автомобилей в Калининграде и области | Недорогой прокат авто с доставкой",
  description: "Автопрокат в Калининграде и области: выгодные цены, новые автомобили. Автопрокат для экскурсий по Куршской косе" +
      "Аренда авто без залога и на длительный срок. Забронируйте машину онлайн за 5 минут!"
};

const Home = () => {

  return (
    <div className="home-page">
      <Helmet>
        <title>{SEO_DATA.title}</title>
        <meta name="description" content={SEO_DATA.description}/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
        </Helmet>
      <Hero/>
      <Suspense fallback={<Loader />}>
        <LazyCarsFeature />
      </Suspense>
      <Carousel/>
      {/* Lazy Loaded Sections */}
      <Suspense fallback={<Loader />}>
        <LazyFeatures />
        <LazyCTA />
        <LazyTestimonials />
      </Suspense>
    </div>
  );
};

export default React.memo(Home);